import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap';
import { UsersService } from '../../../shared/services/users.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { LocalisationService } from '../../../shared/services/localisation.service';
import { BsModalEventsEmitter } from '../../../shared/events/bsModal.events';
import { forkJoin } from 'rxjs';
// tslint:disable-next-line:max-line-length
import { DialCodeSelectorModalComponent } from '../../../shared/components/profile-sections/dial-code-selector-modal/dial-code-selector-modal.component';
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent(usersService, changeDetectorRef, notificationService, localisationService, bsModalService, bsModalEventsEmitter) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.bsModalService = bsModalService;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.editable = true;
        this.notifications = true;
        this.useSwiper = true;
        this.loading = true;
        this.firstName = new FormControl('', [Validators.required]);
        this.surname = new FormControl('', [Validators.required]);
        this.phone = new FormControl('', [Validators.required]);
        this.selectedPhoneDialCode = '';
        // @ts-ignore
        this.dialCodes = require("../../../../../../config/country_dial_codes.json");
        this.selectedPhoneDialCode = '+359';
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        forkJoin(this.usersService.getUserGenders())
            .subscribe(function (_a) {
            var genders = _a[0];
            _this.genders = genders;
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.usersService.userProfile) {
                _this.initCurrentUserProfile(_this.usersService.userProfile);
            }
        });
    };
    SettingsComponent.prototype.onGenderSelected = function (gender) {
        this.currentlySelectedGender = this.genders.find(function (g) { return g.gender === gender; });
    };
    SettingsComponent.prototype.updateProfile = function () {
        var _this = this;
        this.loading = true;
        this.usersService.updateUserProfile({
            first_name: this.firstName.value,
            last_name: this.surname.value,
            dial_code: this.selectedPhoneDialCode,
            phone: this.phone.value,
            gender: {
                id: this.currentlySelectedGender.id
            }
        })
            .subscribe(function () {
            _this.loading = false;
            _this.changeDetectorRef.detectChanges();
            if (_this.notifications) {
                _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
            }
        });
    };
    SettingsComponent.prototype.openDialCodeModal = function () {
        this.dialCodeModal = this.bsModalService.show(DialCodeSelectorModalComponent, {
            backdrop: true
        });
        this.dialCodeModal.content.personalOrWizardComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.dialCodeModal);
    };
    Object.defineProperty(SettingsComponent.prototype, "saveButtonIsDisabled", {
        get: function () {
            return !this.phone.valid || !this.firstName.valid || !this.surname.valid || !this.currentlySelectedGender;
        },
        enumerable: true,
        configurable: true
    });
    SettingsComponent.prototype.initCurrentUserProfile = function (userProfile) {
        this.firstName.setValue(userProfile.first_name);
        this.surname.setValue(userProfile.last_name);
        this.phone.setValue((userProfile.phone === null ? '' : userProfile.phone));
        if (userProfile.dial_code !== null && userProfile.dial_code.length > 0) {
            this.selectedPhoneDialCode = userProfile.dial_code;
        }
        this.currentlySelectedGender = userProfile.gender ? this.genders.find(function (g) { return g.id === userProfile.gender.id; }) : undefined;
        this.changeDetectorRef.markForCheck();
    };
    SettingsComponent.prototype.onDialCodeChange = function (event) {
        this.selectedPhoneDialCode = event.target.value;
        this.changeDetectorRef.markForCheck();
    };
    return SettingsComponent;
}());
export { SettingsComponent };
